import { render } from "./ManageUser.vue?vue&type=template&id=c36d6732"
import script from "./ManageUser.vue?vue&type=script&lang=js"
export * from "./ManageUser.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__